import { createFileRoute } from '@tanstack/react-router';
import { AgencyDetailsPage } from '../features/campaigns/AgencyDetailsPage/AgencyDetailsPage';
import { brandsRouteSearchSchema } from '../features/campaigns/brands/brandsRouteSearch';
export const Route = createFileRoute('/campaigns/agencies_/$agencyId/details')({
  validateSearch: brandsRouteSearchSchema,
  component: DetailsRoute,
});
function DetailsRoute() {
  const { agencyId } = Route.useParams();
  return <AgencyDetailsPage agencyId={agencyId} />;
}
